export default __webpack_public_path__ + "static/media/3140.cea3f318.jpg";